"use strict";

import Track from "./Track.js";

export default class Tracks {
    constructor(props) {
        this.data = props.map((item) => new Track(item));
        this.firstpage = [];
        this.artists = [];
        this.playlists = [];
        this.userManager = null;
    }

    set(object) {
        this.data = object.map((item) => new Track(item));
    }

    get({ id, artistId }) {
        if (id) {
            return this.data.filter((track) => track.get().ID === parseInt(id))[0];
        } else if (artistId) {
            return this.data.filter((track) => track.get().Artists.filter((id) => artistId === id || (id.data && id.data.ID && id.data.ID === artistId))[0]);
        }
        return this.data;
    }

    setUserManager(userManager) {
        this.userManager = userManager;
    }

    setPlaylists(playlists) {
        this.playlists = playlists;
    }

    renderFirstpageList() {
        const container = document.querySelector("#tracksSection");
        const list = container.querySelector(".tracks-list-body");
        if (list) {
            list.textContent = "";
            const elements = 40;
            this.firstpage.map((id, index) => {
                var b = false;
                try {
                    b = (index < elements && list.appendChild(this.get({ id }).renderListItem(this.userManager, this.artists, this.playlists)));
                } catch (e) {
                    console.log("[Tracks - renderFirstpageList] Track "+id+" -- Error: " + e);
                }
                return (b);
                }  
            );
        }
    }

    renderList() {
        const container = document.querySelector("#tracksSection");
        const list = container.querySelector(".tracks-list-body");
        list.textContent = "";
        this.data.map((track) => list.appendChild(track.renderListItem(this.userManager, this.artists, this.playlists)));
    }

    getItem(track) {
        if (!track.length) {
            return track.renderListItem(this.userManager, this.artists, this.playlists);
        }
        return document.createElement("span");
    }

    dispose() {
        this.data = [];
    }
}
